import {RouteInfo} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import {css} from "@emotion/css";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import RaikoCustomTable from "../../raikoComponents/raikoCustomTable/RaikoCustomTable";
import {useEffect, useState} from "react";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {RaikoCustomSimpleChip} from "../../raikoComponents/raikoCustomChip/raikoCustomSimpleChip/RaikoCustomSimpleChip";
import {RaikoChipTypes} from "../../raikoComponents/raikoCustomChip/RaikoChipTypes";
import {NewsService} from "../../serverService/newsService/NewsService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import AddNews from "../../component/addNews/AddNews";
import {useNavigate} from "react-router-dom";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";

export default function NewsList() {

    let page = 0;
    const size = 15;
    const service = new NewsService()

    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const navigate = useNavigate()


    const [tableList, setTableList] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);

    function handlePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function handleShowDetail(rowId) {
        navigate(RouteInfo.NewsDetail.globalUrl.replace(":id", rowId))
    }


    useEffect(() => {
        if (typeof service != "undefined") {
            getDataFromServer()
        }
    }, [])

    function getDataFromServer() {
        setTableLoading(true)
        service.getNewsList(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setTableList([])

                response.data.map((item, index) => {
                    setTableList(prevState => [
                        ...prevState,
                        prepareTableRow(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.published,
                            item.createdBy,
                            convertUniversalDateToPersianDate(item.createdAt),
                            item.thumbnail && item.thumbnail.url ? item.thumbnail.url : ""
                        )
                    ])
                })

                setTableLoading(false)
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت لیست اخبار"))
            setTableLoading(false)
        })
    }

    function prepareTableRow(id, number, title, published, creator, createdDate, thumbnail) {
        return {
            id,
            number,
            createdDate,
            creator,
            title: title,
            published: published ?
                <RaikoCustomSimpleChip title={"منتشر شده"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"منتشر نشده"} type={RaikoChipTypes.error}/>
        };
    }


    const [addNewsDialogOpenState, setAddNewsDialogOpenState] = useState(false);

    function openAddNewsDialog() {
        setAddNewsDialogOpenState(true)
    }

    function closeAddNewsDialog() {
        setAddNewsDialogOpenState(false)
    }

    function handleAddNewsToList(newItem) {
        if (page === 0) {
            setTableLoading(true)
            const _tableList = tableList
            setTableList([])
            _tableList.map((item, index) => {
                if (index === 0) {
                    setTableList([prepareTableRow(
                        newItem.id,
                        1,
                        newItem.title,
                        false,
                        newItem.createdBy,
                        convertUniversalDateToPersianDate(newItem.createdAt),
                        ""
                    )])
                }

                setTableList(prevState => [
                    ...prevState,
                    {
                        ...item,
                        number: (page * size) + index + 2
                    }
                ])
            })

            setTableLoading(false)
        }
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.NewsList.name}</title>
            </Helmet>

            <RaikoDefaultDialogPage
                dialogSize={DialogSize.SMALL}
                onClose={closeAddNewsDialog}
                open={addNewsDialogOpenState}>
                <AddNews
                    handleAddToRow={handleAddNewsToList}
                    handleCloseDialog={closeAddNewsDialog}
                />
            </RaikoDefaultDialogPage>


            <section
                className={css`
                  padding: 26px 0;
                  overflow: hidden;
                `}>

                <RaikoBreadcrumb
                    breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            "اخبار",
                            ""
                        ),
                        raikoBreadCrumbItemGenerator(
                            "لیست اخبار",
                            RouteInfo.NewsList.globalUrl
                        ),
                    ]}
                />

                <RaikoBaseCardContainer
                    className={`${css`
                      margin-top: 40px;
                    `}`}>


                    <ButtonDivisionSection>
                        {/*<RaikoMaterialOutlinedInput
                            labelText={"جست و جو"}
                            className="flex-grow-1"
                            spellCheck={false}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <div className={"search-icon"}/>
                                    </InputAdornment>
                                ),
                            }}
                            placeHolder={"عبارت مورد نظر خود را وارد نمایید."}
                        />*/}

                        <ButtonPrimaryRaiko
                            label={"افزودن"}
                            className={css`
                              height: max-content !important;
                            `}
                            onClick={openAddNewsDialog}
                        />
                    </ButtonDivisionSection>

                    <div className={css`
                      width: 100%;
                      margin-top: 1rem;
                      overflow-x: scroll !important;
                    `}>
                        <RaikoCustomTable
                            data={tableList}
                            header={columns}
                            isLoading={tableLoading}
                            pageCount={pageCount}
                            handlePaginationChange={handlePagination}
                            rowClicked={handleShowDetail}
                        />
                    </div>


                </RaikoBaseCardContainer>

            </section>
        </>
    )
}

const columns = [
    {
        id: 'number',
        label: '#'
    }, {
        id: 'title',
        label: 'عنوان'
    }, {
        id: 'createdDate',
        label: 'تاریخ ساخت'
    }, {
        id: 'creator',
        label: 'سازنده',
    }, {
        id: 'published',
        label: 'وضعیت انتشار',
    },
];
